import { render, staticRenderFns } from "./ModalNovidades.vue?vue&type=template&id=7119c85c"
import script from "./ModalNovidades.vue?vue&type=script&lang=js"
export * from "./ModalNovidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports